module.exports = __webpack_public_path__ + "static/media/Single Mat with Logo.5fffbbed.png";